import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnet = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.9867 8.6121L15.2464 5.879L13.5338 4.17082C13.3054 3.94306 12.9629 3.94306 12.7345 4.17082L10.1085 6.79004C9.88011 7.01779 9.88011 7.35943 10.1085 7.58719L14.5614 12.0285C15.3035 12.7687 15.3035 13.9075 14.6185 14.5907C14.2759 14.9324 13.8192 15.1032 13.3625 15.1032C12.9058 15.1032 12.392 14.8754 12.0495 14.5338L9.30923 11.8007L7.59657 10.0925C7.36822 9.86477 7.02569 9.86477 6.79734 10.0925L4.17127 12.7117C3.94291 12.9395 3.94291 13.2811 4.17127 13.5089L8.62417 17.9502C9.9372 19.2598 11.5928 19.9431 13.4196 20C13.4767 20 13.4767 20 13.5338 20C15.3035 20 16.902 19.3167 18.1579 18.121C20.6698 15.5587 20.6128 11.2883 17.9867 8.6121ZM13.1342 5.42349L14.0476 6.33452L12.2207 8.15658L11.3073 7.24555L13.1342 5.42349ZM7.19696 11.3452L8.11037 12.2562L6.28354 14.0783L5.37012 13.1673L7.19696 11.3452Z",
		fill: "currentColor"
	})
});
export default SvgMagnet;
